import { LockOutlined, UserOutlined } from '@ant-design/icons';
import { App as AntApp, Button, Card, Form, Input, Typography } from 'antd';
import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useLogin, useMe } from '../api/hooks';
import { extractErrorMessage } from '../api/client';

const { Title, Text } = Typography;

export default function LoginPage() {
  const navigate = useNavigate();
  const login = useLogin();
  const { message } = AntApp.useApp();
  const { data: me } = useMe({ retry: false });

  // Nếu đã đăng nhập rồi thì vào thẳng dashboard.
  useEffect(() => {
    if (me?.username) navigate('/', { replace: true });
  }, [me, navigate]);

  const onFinish = async (values: { username: string; password: string }) => {
    try {
      await login.mutateAsync(values);
      message.success('Đăng nhập thành công');
      navigate('/', { replace: true });
    } catch (e) {
      message.error(extractErrorMessage(e, 'Sai tài khoản hoặc mật khẩu'));
    }
  };

  return (
    <div
      style={{
        minHeight: '100vh',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        background: 'linear-gradient(135deg, #1677ff22, #f0f2f5)',
      }}
    >
      <Card style={{ width: 380, boxShadow: '0 4px 24px rgba(0,0,0,0.08)' }}>
        <div style={{ textAlign: 'center', marginBottom: 24 }}>
          <Title level={3} style={{ marginBottom: 4 }}>
            Bảng quản trị
          </Title>
          <Text type="secondary">API Gateway Platform</Text>
        </div>
        <Form layout="vertical" onFinish={onFinish} requiredMark={false}>
          <Form.Item
            label="Tên đăng nhập"
            name="username"
            rules={[{ required: true, message: 'Vui lòng nhập tên đăng nhập' }]}
          >
            <Input prefix={<UserOutlined />} placeholder="Tên đăng nhập" size="large" />
          </Form.Item>
          <Form.Item
            label="Mật khẩu"
            name="password"
            rules={[{ required: true, message: 'Vui lòng nhập mật khẩu' }]}
          >
            <Input.Password prefix={<LockOutlined />} placeholder="Mật khẩu" size="large" />
          </Form.Item>
          <Form.Item style={{ marginBottom: 0 }}>
            <Button
              type="primary"
              htmlType="submit"
              block
              size="large"
              loading={login.isPending}
            >
              Đăng nhập
            </Button>
          </Form.Item>
        </Form>
      </Card>
    </div>
  );
}
